import axios from 'axios'
import { showToast } from 'vant'
import CryptoJS from 'crypto-js'
import store from '@/store'
import Aces from '@/uilts/Aces'

// 创建axios实例
const service = axios.create({
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded' // 设置默认的 Content-Type
    },
    timeout: 5000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        return config
    },
    error => {
        showToast(error)
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        try {
            const res = JSON.parse(Aces.Decrypt(response.data))
            const showTip = response.config.showTip !== false
            if (res.code == -1) {
                if (showTip) {
                    showToast(res.msg)
                }
                return false
            } else if (res.code == 660) {
                localStorage.removeItem('token')
                localStorage.removeItem('uuid')
                localStorage.removeItem('nickName')
                showToast('请先登录')
                setTimeout(() => {
                    window.location.reload()
                }, 1000)
                return false
            }
            return res
        } catch (e) {
            showToast('数据解析失败')
            return false
        }
    },
    error => {
        if (error.response) {
            const res = error.response.data
            return Promise.reject(new Error(res.msg))
        }
    }
)

// 封装请求方法
function intercept(url, params, showTip = true) {
    return service.post(url, params, { showTip }).then(response => {
        return response
    }).catch(error => {
        if (showTip) {
            showToast(error.msg)
        }
        throw error
    })
}

// 封装请求方法（上传）
function interceptUpload(url, params, processedParams) {
    for (const i in processedParams) {
        params.append(i, processedParams[i])
    }
    return axios.post(url, params, {
        headers: {
            'Content-Type': 'multipart/form-data' // 设置默认的 Content-Type
        },
        timeout: 5000 // 请求超时时间
    }).then(response => {
        const res = response.data
        if (res.code == -1) {
            showToast(res.msg)
            return false
        } else if (res.code == 660) {
            localStorage.removeItem('token')
            localStorage.removeItem('uuid')
            localStorage.removeItem('nickName')
            window.location.reload()
            return false
        }
        return res
    }).catch(error => {
        showToast(error.msg)
        throw error
    })
}

export {
    intercept,
    interceptUpload
}